import ContactForm from "@/components/feature/ContactForm";
import { siteInfo } from "@/mocks/site";

const channels = [
  {
    icon: "ri-mail-send-line",
    title: "线索投递邮箱",
    value: siteInfo.contactEmail,
    desc: "适合附带截图、录屏等原始材料，邮件标题建议注明事件关键词。",
  },
  {
    icon: "ri-time-line",
    title: "编辑值守时间",
    value: "每日 08:00 - 24:00",
    desc: "节假日不间断值守，重大节点的更新会在值守时段内优先处理。",
  },
  {
    icon: "ri-timer-flash-line",
    title: "核实与反馈",
    value: "48 小时内",
    desc: "收到线索后会先做时间与来源核对，需要补充材料时会主动回信确认。",
  },
];

export default function ContactSection() {
  return (
    <section className="py-14 md:py-20">
      <div className="max-w-shell mx-auto px-4 md:px-6 grid grid-cols-1 lg:grid-cols-12 gap-10">
        <div className="lg:col-span-5 flex flex-col gap-5">
          <div>
            <span className="inline-flex items-center gap-2 text-xs tracking-[0.2em] text-primary-700 uppercase">
              <span className="w-6 h-px bg-primary-400" />
              Contact
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              联系我们与线索投递
            </h2>
            <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-600">
              如果你掌握与现有时间线不符的材料，或希望补充某条事件的最新进展，欢迎通过下面的方式联系我们。请尽量写明时间、出处与可核查的原始材料。
            </p>
          </div>

          <div className="flex flex-col gap-4">
            {channels.map((item) => (
              <article
                key={item.title}
                className="flex items-start gap-4 p-5 rounded-lg bg-background-50 border border-background-200"
              >
                <span className="w-10 h-10 rounded-md bg-secondary-100 text-secondary-700 flex items-center justify-center shrink-0 text-lg">
                  <i className={item.icon} />
                </span>
                <div>
                  <h3 className="text-sm font-medium text-foreground-950">{item.title}</h3>
                  <p className="mt-0.5 text-sm text-primary-700 break-all">{item.value}</p>
                  <p className="mt-1.5 text-xs leading-relaxed text-foreground-500">{item.desc}</p>
                </div>
              </article>
            ))}
          </div>
        </div>

        <div className="lg:col-span-7">
          <div className="rounded-lg border border-background-200 bg-background-100 p-6 md:p-8">
            <h3 className="font-heading text-lg font-bold text-foreground-950">线索投递表</h3>
            <p className="mt-2 text-sm text-foreground-600">
              带 * 的为必填项。提交后会直接进入编辑核实队列，我们不会公开你的联系方式。
            </p>
            <div className="mt-6">
              <ContactForm />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}